export default {
  data() {
    return {
      entry: {
        features: [],
        headerContent: [{ heading: '', body: '' }],
        headerImage: [],
        intro: [{ heading: '', body: '' }],
        steps: [{ heading: '', items: [] }],
        willFeatures: [
          {
            family: [
              {
                title: '',
                heading: '',
                image: [],
              },
            ],
            estate: [
              {
                title: '',
                heading: '',
                image: [],
              },
            ],
            pets: [
              {
                title: '',
                heading: '',
                image: [],
              },
            ],
            charities: [
              {
                title: '',
                heading: '',
                image: [],
              },
            ],
          },
        ],
      },
    };
  },
};
